import Vue from 'vue'
import App from './App.vue'
import router from './router'
import routerBefore from './router/routerBefor'
import store from './store'
import 'lib-flexible/flexible'
import '@/utils/flexible'
import chartResize from '@/utils/eChartResiz'
// 引用日期选择器
import { DatePicker } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(DatePicker)
// 通用样式文件
import './assets/css/index.less'
Vue.config.productionTip = false
Vue.prototype.$chartResize = chartResize
Vue.prototype.$formatDate = formatDate
new Vue({
  router,
  routerBefore,
  store,
  render: h => h(App)
}).$mount('#app')



// 格式化时间
function formatDate (time) {
  if (time) {
    const date = new Date(time)
    // 注意js里面的getMonth是从0开始的
    let FormattedDateTime = {}
    const year = date.getFullYear()
    let month = (date.getMonth() + 1)
    let day = date.getDate()
    let h = date.getHours()
    let m = date.getMinutes()
    let s = date.getSeconds()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    h = h < 10 ? '0' + h : h
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    FormattedDateTime.year = year + '-' + month + '-' + day   
    FormattedDateTime.hours = h + ':' + m + ':' + s
    return FormattedDateTime
  }
  return null
}
